import React, { useRef, useState, useEffect } from "react";
import "./style.css";

import styles from "styles.module.css";
import { PageTypePath } from "utils/pages";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { addMonths, addWeeks } from "date-fns";
import OverLayLoading from "ui/Loading";
import { useTranslation } from "react-i18next";
import { pickListGridColumnItem } from "./utils/GridColumns";
import Filter from "./Filter";
import { getPickListApi, PickListFilter } from "api/pickList";
import { useUserStore } from "store/user";
import { UserRole } from "interface/user";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
// import style from "./style.module.css";

const pageSize = 60;

const PickListPage = () => {
	const { t } = useTranslation();
	const { roles } = useUserStore();

	const overlayRef = useRef<HTMLDivElement>(null);

	var fromDate = addWeeks(new Date(), -1);

	//if (roles.includes(UserRole.Admin)) {
	//	fromDate = addWeeks(new Date(), -1);
	//}

	const gridRef = useRef<HTMLDivElement>(null);
	const [filterOptions, setFilterOptions] = useState<PickListFilter>({
		take: pageSize,
		skip: 0,
		fromDate: fromDate,
		toDate: new Date(),
	});

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);
	const [gridData, setGridData] = useState<any[]>([]);

	const exportGridAsPDF = () => {
		const fromDate = filterOptions.fromDate instanceof Date ? filterOptions.fromDate.toISOString() : "";
		const toDate = filterOptions.toDate instanceof Date ? filterOptions.toDate.toISOString() : "";
		localStorage.setItem("fromDate", fromDate);
		localStorage.setItem("toDate", toDate);
		localStorage.setItem("buyerId", filterOptions.buyerId ?? "");

		window.open(`/${PageTypePath.Pdf}/0/1/`, "_blank");
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	return (
		<div className={styles.PageContainer}>
			<div ref={overlayRef} style={{ display: "none" }}>
				<OverLayLoading />
			</div>
			<div className="page-header">
				<legend className={styles.BoxHeadingLarge}>{t("PickList")}</legend>
			</div>

			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
				/>
			</div>
			<div style={{}} ref={gridRef}>
				<GridWithGroupPaging
					gridColumns={pickListGridColumnItem(gridData)}
					filter={filterOptions}
					exportGridAsPDFRef={pdfRef}
					exportGridAsExcelRef={excelRef}
					apiMethod={getPickListApi}
					sortable={{ mode: "multiple" }}
					defaultSort={[{ field: "productName", dir: "asc" }]}
					itemAboveHeight={50}
					pageable={false}
					groupable={{ footer: "visible", enabled: false }}
					onFilteredDataChange={setGridData}
					//gridStyle={{ height: "unset", maxHeight: "unset" }}
					group={[
						{
							field: "group1",
						},
						{
							field: "group2",
							aggregates: [{ field: "netLiveWeightKg", aggregate: "sum" }],
						},
					]}
				/>
			</div>
		</div>
	);
};

export default PickListPage;
